AFRAME.registerComponent('configure-control', {
    schema: {
        isAnimationOn: { type: 'boolean', default: true },
        isGlowOn: { type: 'boolean', default: false },
        isFireworkOn: { type: 'boolean', default: false },
        chartMathFunction: { type: 'string', default: 'Linear' },
        glowThreshold: { type: 'string', default: '+100%' },
        fireworkThreshold: { type: 'string', default: '+3%' },
        isGlobeVisible: { type: 'boolean', default: true },
    },

    init: function () {

        this._initVariables();


        this.STORAGE_KEY = 'configureControlSettings';
        // User preferences use PERSISTENT expiration (10 years)
        this.EXPIRATION_TIME = typeof CACHE_EXPIRATION !== 'undefined' ? CACHE_EXPIRATION.PERSISTENT : 5256000;

        this.themeMode = 'Dark';
        const mainSettings = getCacheItem('mainSettings');
        if (mainSettings && mainSettings.themeMode) {
            this.themeMode = mainSettings.themeMode;
        }

        window.addEventListener('theme-changed', (e) => {
            if (e.detail && e.detail.themeMode) {
                this.themeMode = e.detail.themeMode;
                this.applySettings();
                this.createHeader();
                this.createSettingsList();
            }
        });

        document.addEventListener('auth:session-changed', () => {
            this.createSettingsList();
        });

        this.createHeader();

        const stored = this._loadSettings();
        if (stored) {
            const toApply = {};
            Object.keys(this.schema).forEach((key) => {
                if (Object.prototype.hasOwnProperty.call(stored, key)) {
                    toApply[key] = stored[key];
                }
            });
            if (Object.keys(toApply).length) {
                this.el.setAttribute('configure-control', toApply);
            }
        } else {
            this._saveSettings();
        }

        this.createSettingsList();

        this.applySettings();
        
        if (window.PopupManager) {
            window.PopupManager.register('configure-control', this.el);
        }

        try {
            if (window.Fireworks && 'isFireworkOn' in this.data) {
                const enabled = this.data.isFireworkOn;
                window.Fireworks.toggleFireworks(enabled);
            }
        } catch (e) {
            console.warn('hubi: Failed to sync Fireworks state', e);
        }

        this._isMmapActive = false;
        this.el.sceneEl.addEventListener('chart-type-changed', (e) => {
            const isMmap = e.detail && e.detail.action === 'mmap';
            if (this._isMmapActive !== isMmap) {
                this._isMmapActive = isMmap;
                this.createSettingsList();
            }
        });
        this.el.sceneEl.addEventListener('mmap-mode-changed', () => {
            if (this._isMmapActive) this.createSettingsList();
        });
        setTimeout(() => {
            const cached = typeof getCacheItem !== 'undefined' ? getCacheItem('lastChartType') : null;
            if (cached && cached.startsWith('mmap')) {
                this._isMmapActive = true;
                this.createSettingsList();
            }
        }, 300);
    },


    applySettings: function () {
        const isLight = this.themeMode === 'Light';
        if (this.popupBgDark) this.popupBgDark.setAttribute('visible', !isLight);
        if (this.popupBgLight) this.popupBgLight.setAttribute('visible', isLight);
    },

    _initVariables: function () {
        this.popupBgDark = this.el.querySelector('.background-panel-dark');
        this.popupBgLight = this.el.querySelector('.background-panel-light');
    },


    _loadSettings: function () {
        try {
            const data = getCacheItem(this.STORAGE_KEY);
            console.log('Loaded settings from cache:', data);
            return data;
        } catch (e) {
            console.warn('Failed to load configure settings', e);
            return null;
        }
    },

    _saveSettings: function () {
        try {
            const payload = {};
            Object.keys(this.schema).forEach((key) => {
                payload[key] = this.data[key];
            });
            setCacheItem(this.STORAGE_KEY, payload, this.EXPIRATION_TIME);
            console.log('Saved configure settings to cache with expiration:', this.EXPIRATION_TIME);
        } catch (e) {
            console.warn('Failed to save configure settings', e);
        }
    },

    createHeader: function () {
        const isLight = this.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';

        // main text
        const title = document.createElement('a-troika-text');
        title.setAttribute('value', 'Configure');
        title.setAttribute('font-size', 0.03);
        title.setAttribute('color', txtColor);
        title.setAttribute('anchor', 'center');
        title.setAttribute('position', `0 0.43 0.01`)
        this.el.appendChild(title);

        // close button
        const cross = document.createElement('a-text');
        cross.setAttribute('value', 'X');
        // cross.setAttribute('font-size', 0.04);
        cross.setAttribute('scale', '0.15 0.1 0.1');
        cross.setAttribute('color', txtColor);
        cross.setAttribute('anchor', 'center');
        cross.setAttribute('align', 'center');
        cross.setAttribute('position', `0.26 0.43 0.01`)
        this.el.appendChild(cross);

        // clickable area
        const interactivePlane = document.createElement('a-plane');
        interactivePlane.setAttribute('id', 'close-configure-popup');
        interactivePlane.setAttribute('height', 0.04);
        interactivePlane.setAttribute('width', 0.04);
        interactivePlane.setAttribute('position', `0.26 0.43 0.01`);
        interactivePlane.setAttribute('opacity', '0');
        interactivePlane.setAttribute('data-raycastable', '');
        interactivePlane.addEventListener('click', () => {
            if (window.PopupManager) {
                window.PopupManager.close('configure-control');
            } else {
                this.el.setAttribute('visible', false);
            }
        })
        this.el.appendChild(interactivePlane);

    },

    createSettingsList: function () {
        const { isAnimationOn, isGlowOn, isFireworkOn, chartMathFunction, glowThreshold, fireworkThreshold } = this.data;

        const isMmapActive = this._isMmapActive;
        const currentMmapMode = window.MarketMapModeSwitching ? window.MarketMapModeSwitching.getCurrentMode() : '2d';
        const isMmap3D = isMmapActive && currentMmapMode === '3d';

        const list = [

            { key: 'isAnimationOn', label: 'Animation', isActive: isAnimationOn, type: 'toggle' },
            // { key: 'isAnimationLastFrameOn', label: 'Play animation from last frame', isActive: isAnimationLastFrameOn, isDisabled: !isAnimationOn, type: 'toggle' },
            { key: 'isGlowOn', label: 'Pulsating Glow', subLabel: 'for “active stocks"', isActive: isGlowOn, type: 'toggle', leftMargin: 0.17 },
            { key: 'glowThreshold', label: 'Glow threshold', value: glowThreshold, type: 'select' },
            { key: 'isFireworkOn', label: 'Fireworks effects', subLabel: 'for “big gains from the watch list”', isActive: isFireworkOn, type: 'toggle', leftMargin: 0.19 },
            { key: 'fireworkThreshold', label: 'Firework threshold', value: fireworkThreshold, type: 'select' },
            { key: 'chartMathFunction', label: 'Chart function', value: chartMathFunction, type: 'select' },

        ]

        const contentElement = this.el.querySelector('#configure-control-content');
        contentElement.innerHTML = '';
        const itemHeight = 0.06;
        const itemWidth = 0.56;
        const itemSpacing = 0.02;
        const padding = 0.02;
        const mainLabelFontSize = 0.02;
        const subLabelFontSize = 0.018;

        const isLight = this.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';
        const itemBgColor = isLight ? '#1e1e1e' : '#fff';
        const itemBgOpacity = '0.02';

        const selectColor = isLight ? '#3636E3' : '#FFFFFF';
        const selectedTextColor = isLight ? '#FFFFFF' : '#14141C';

        let isAuth = false;
        try {
            let session = window.currentSession;
            if (!session && typeof window.AuthAPI !== 'undefined' && typeof window.AuthAPI.getStoredSession === 'function') {
                session = window.AuthAPI.getStoredSession();
            }
            if (!session) {
                const sessionStr = localStorage.getItem('auth_session');
                if (sessionStr) {
                    const sessionItem = JSON.parse(sessionStr);
                    session = sessionItem.value || sessionItem;
                    const expiry = sessionItem.expiry;
                    if (expiry && Date.now() > expiry) {
                        session = null;
                    }
                }
            }
            if (session && (!session.user || !session.user.is_anonymous)) {
                isAuth = true;
            }
        } catch (e) {
            let session = window.currentSession;
            if (session && (!session.user || !session.user.is_anonymous)) {
                isAuth = true;
            }
        }

        list.forEach((item, index) => {
            let itemDisabled = isMmapActive && (isMmap3D || item.key !== 'isAnimationOn');
            if (!isAuth && (item.key === 'isFireworkOn' || item.key === 'fireworkThreshold')) {
                itemDisabled = true;
            }
            const effectiveTxtColor = itemDisabled ? '#666666' : txtColor;
            const itemElement = document.createElement('a-entity');
            if (item.type === 'toggle') {
                // bg
                const bg = document.createElement('a-rounded-plane');
                bg.setAttribute('id', `item-bg-${index}`);
                bg.setAttribute('height', itemHeight);
                bg.setAttribute('width', itemWidth);
                bg.setAttribute('radius', '0.01');
                bg.setAttribute('color', itemBgColor);
                bg.setAttribute('opacity', itemBgOpacity);
                bg.setAttribute('position', `0 ${-itemHeight / 2} 0.002`);
                itemElement.appendChild(bg);

                // clickable area
                const interactivePlane = document.createElement('a-plane');
                interactivePlane.setAttribute('height', itemHeight);
                interactivePlane.setAttribute('width', itemWidth);
                interactivePlane.setAttribute('position', `${itemWidth / 2} 0 0.001`);
                interactivePlane.setAttribute('opacity', '0');
                interactivePlane.setAttribute('data-raycastable', '');
                
                if (!itemDisabled) {
                    interactivePlane.addEventListener('click', () => {
                        const newValue = !this.data[item.key];
                        this.el.setAttribute('configure-control', item.key, newValue);
                        this.createSettingsList();

                        if (item.key === 'isFireworkOn' && window.Fireworks) {
                            window.Fireworks.toggleFireworks(newValue);
                        }
                        
                        if (window.gtag) {
                            let eventName = 'Desktop_CenterPanel_Configure_';
                            let eventObj = { value: newValue ? 'On' : 'Off'}
                            
                            if (item.key === 'isAnimationOn') eventName += 'Animation'; 
                            if (item.key === 'isGlowOn') eventName += 'Glow'; 
                            if (item.key === 'isFireworkOn') eventName += 'Fireworks';

                            gtag('event', eventName, eventObj);
                        }
                    });
                } else {
                    interactivePlane.addEventListener('click', (e) => {
                        if (e.detail && e.detail.cursorEl) {
                            e.stopPropagation();
                        }
                    });
                }
                itemElement.appendChild(interactivePlane);

                // main text
                const mainLabel = document.createElement('a-troika-text');
                mainLabel.setAttribute('value', item.label);
                mainLabel.setAttribute('font-size', mainLabelFontSize);
                mainLabel.setAttribute('color', effectiveTxtColor);
                mainLabel.setAttribute('anchor', 'left');
                mainLabel.setAttribute('position', `${padding} 0 0.01`)
                itemElement.appendChild(mainLabel);

                // sub text
                if (item.subLabel) {
                    const subLabel = document.createElement('a-troika-text');
                    subLabel.setAttribute('value', item.subLabel);
                    subLabel.setAttribute('font-size', subLabelFontSize);
                    subLabel.setAttribute('color', effectiveTxtColor);
                    subLabel.setAttribute('anchor', 'left');
                    subLabel.setAttribute('position', `${item.leftMargin || 0} 0 0.01`)
                    subLabel.setAttribute('fill-opacity', '0.5')
                    itemElement.appendChild(subLabel);
                }

                // toggle
                const toggleContainer = document.createElement('a-entity');
                toggleContainer.setAttribute('position', '0.52 0 0.01');

                const toggleBg = document.createElement('a-rounded-plane');
                toggleBg.setAttribute('position', '-0.03 -0.01 0');
                toggleBg.setAttribute('color', isLight ? '#1E1E1E' : '#fff');
                toggleBg.setAttribute('opacity', itemDisabled ? '0.02' : '0.05');
                toggleBg.setAttribute('height', 0.02);
                toggleBg.setAttribute('width', 0.06);
                toggleBg.setAttribute('radius', 0.006);
                toggleContainer.appendChild(toggleBg);

                const toggleButton = document.createElement('a-rounded-plane');
                toggleButton.setAttribute('position', item.isActive ? '0 -0.015 0.005' : '-0.03 -0.015 0.005');
                toggleButton.setAttribute('width', 0.03);
                toggleButton.setAttribute('height', 0.03);
                const toggleBtnColor = itemDisabled ? '#444444' : (item.isActive ? selectColor : (isLight ? '#737373' : '#4F4F4F'));
                toggleButton.setAttribute('color', toggleBtnColor);
                toggleButton.setAttribute('radius', 0.003);
                toggleContainer.appendChild(toggleButton);

                itemElement.appendChild(toggleContainer);
            }

            if (item.key === 'chartMathFunction') {
                const bg = document.createElement('a-rounded-plane');
                bg.setAttribute('id', `item-bg-${index}`);
                bg.setAttribute('height', itemHeight);
                bg.setAttribute('width', itemWidth);
                bg.setAttribute('radius', '0.01');
                bg.setAttribute('color', itemBgColor);
                bg.setAttribute('opacity', itemBgOpacity);
                bg.setAttribute('position', `0 ${-itemHeight / 2} 0.002`);
                itemElement.appendChild(bg);

                // main text
                const mainLabel = document.createElement('a-troika-text');
                mainLabel.setAttribute('value', item.label);
                mainLabel.setAttribute('font-size', mainLabelFontSize);
                mainLabel.setAttribute('color', effectiveTxtColor);
                mainLabel.setAttribute('anchor', 'left');
                mainLabel.setAttribute('position', `${padding} 0 0.01`)
                itemElement.appendChild(mainLabel);

                // variants
                const isLog = this.data.chartMathFunction === 'Log';
                const isLin = this.data.chartMathFunction === 'Linear';

                const logVar = document.createElement('a-troika-text');
                logVar.setAttribute('value', 'Log');
                logVar.setAttribute('font-size', mainLabelFontSize);
                logVar.setAttribute('color', itemDisabled ? '#666666' : (isLog ? selectedTextColor : txtColor));
                logVar.setAttribute('anchor', 'center');
                logVar.setAttribute('position', `0.327 0 0.01`)
                itemElement.appendChild(logVar);

                const linearVar = document.createElement('a-troika-text');
                linearVar.setAttribute('value', 'Linear');
                linearVar.setAttribute('font-size', mainLabelFontSize);
                linearVar.setAttribute('color', itemDisabled ? '#666666' : (isLin ? selectedTextColor : txtColor));
                linearVar.setAttribute('anchor', 'center');
                linearVar.setAttribute('position', `0.477 0 0.01`)
                itemElement.appendChild(linearVar);

                const semitransparentPlane = document.createElement('a-rounded-plane');
                semitransparentPlane.setAttribute('height', 0.044);
                semitransparentPlane.setAttribute('width', 0.3);
                semitransparentPlane.setAttribute('radius', '0.01');
                semitransparentPlane.setAttribute('opacity', itemDisabled ? '0.02' : '0.05');
                semitransparentPlane.setAttribute('color', isLight ? '#000' : '#fff');
                semitransparentPlane.setAttribute('position', '0.252 -0.022 0.003');
                itemElement.appendChild(semitransparentPlane);

                const selectPlane = document.createElement('a-rounded-plane');
                selectPlane.setAttribute('height', 0.044);
                selectPlane.setAttribute('width', 0.15);
                selectPlane.setAttribute('radius', '0.01');
                selectPlane.setAttribute('color', itemDisabled ? '#444444' : selectColor);
                if (itemDisabled) selectPlane.setAttribute('opacity', '0.5');
                selectPlane.setAttribute('position', `${this.data.chartMathFunction === 'Log' ? 0.252 : 0.402} -0.022 0.004`);
                itemElement.appendChild(selectPlane);

                // clickable area
                const interactivePlane1 = document.createElement('a-plane');
                interactivePlane1.setAttribute('height', 0.044);
                interactivePlane1.setAttribute('width', 0.15);
                interactivePlane1.setAttribute('opacity', '0');
                interactivePlane1.setAttribute('data-raycastable', '');
                
                const interactivePlane2 = interactivePlane1.cloneNode();
                interactivePlane1.setAttribute('position', `0.327 0 0.001`);
                interactivePlane2.setAttribute('position', `0.477 0 0.001`);
                if (!itemDisabled) {
                    interactivePlane1.addEventListener('click', () => {
                        this.el.setAttribute('configure-control', 'chartMathFunction', 'Log');
                        this.createSettingsList();

                        if (window.gtag) gtag('event', `VR_CenterPanel_Configure_ChartFunction`, { value: 'Log'} );
                    });
                    interactivePlane2.addEventListener('click', () => {
                        this.el.setAttribute('configure-control', 'chartMathFunction', 'Linear');
                        this.createSettingsList();

                        if (window.gtag) gtag('event', `VR_CenterPanel_Configure_ChartFunction`, { value: 'Linear'} );
                    });
                } else {
                    const stopClick = (e) => e.stopPropagation();
                    interactivePlane1.addEventListener('click', stopClick);
                    interactivePlane2.addEventListener('click', stopClick);
                }
                itemElement.appendChild(interactivePlane1);
                itemElement.appendChild(interactivePlane2);

            }


            if (item.key === 'glowThreshold') {

                const bg = document.createElement('a-rounded-plane');
                bg.setAttribute('id', `item-bg-${index}`);
                bg.setAttribute('height', itemHeight);
                bg.setAttribute('width', itemWidth);
                bg.setAttribute('radius', '0.01');
                bg.setAttribute('color', itemBgColor);
                bg.setAttribute('opacity', itemBgOpacity);
                bg.setAttribute('position', `0 ${-itemHeight / 2} 0.002`);
                itemElement.appendChild(bg);

                // main text
                const mainLabel = document.createElement('a-troika-text');
                mainLabel.setAttribute('value', item.label);
                mainLabel.setAttribute('font-size', mainLabelFontSize);
                mainLabel.setAttribute('color', effectiveTxtColor);
                mainLabel.setAttribute('anchor', 'left');
                mainLabel.setAttribute('position', `${padding} 0 0.01`)
                itemElement.appendChild(mainLabel);

                const thresholds = ['+25%', '+50%', '+100%', '+150%', '+200%'];
                const optionWidth = 0.07;
                const optionHeight = 0.044;
                const xLeft = 0.198;
                const selectedIndex = Math.max(0, thresholds.indexOf(this.data.glowThreshold));

                const semitransparentPlane = document.createElement('a-rounded-plane');
                semitransparentPlane.setAttribute('height', optionHeight);
                semitransparentPlane.setAttribute('width', optionWidth * thresholds.length);
                semitransparentPlane.setAttribute('radius', '0.01');
                semitransparentPlane.setAttribute('opacity', itemDisabled ? '0.02' : '0.05');
                semitransparentPlane.setAttribute('color', isLight ? '#000' : '#fff');
                semitransparentPlane.setAttribute('position', `${xLeft} -0.022 0.003`);
                itemElement.appendChild(semitransparentPlane);

                const selectPlane = document.createElement('a-rounded-plane');
                selectPlane.setAttribute('height', optionHeight);
                selectPlane.setAttribute('width', optionWidth);
                selectPlane.setAttribute('radius', '0.01');
                selectPlane.setAttribute('color', itemDisabled ? '#444444' : selectColor);
                selectPlane.setAttribute('position', `${xLeft + optionWidth * selectedIndex} -0.022 0.004`);
                itemElement.appendChild(selectPlane);

                // options
                thresholds.forEach((val, i) => {
                    const centerX = xLeft + optionWidth * i + optionWidth / 2;
                    const optionText = document.createElement('a-troika-text');
                    optionText.setAttribute('value', val);
                    optionText.setAttribute('font-size', 0.018);
                    optionText.setAttribute('anchor', 'center');
                    const isSelected = i === selectedIndex;
                    optionText.setAttribute('color', itemDisabled ? '#666666' : (isSelected ? selectedTextColor : txtColor));
                    optionText.setAttribute('position', `${centerX} 0 0.01`);
                    itemElement.appendChild(optionText);

                    const interactivePlane = document.createElement('a-plane');
                    interactivePlane.setAttribute('height', optionHeight);
                    interactivePlane.setAttribute('width', optionWidth);
                    interactivePlane.setAttribute('opacity', '0');
                    interactivePlane.setAttribute('data-raycastable', '');
                    interactivePlane.setAttribute('position', `${centerX} 0 0.001`);
                    if (!itemDisabled) {
                        interactivePlane.addEventListener('click', () => {
                            console.log('click', i)
                            this.el.setAttribute('configure-control', 'glowThreshold', val);
                            this.createSettingsList();

                            if (window.gtag) gtag('event', `VR_CenterPanel_Configure_GlowThreshold`, { value: val });
                        });
                    } else {
                        interactivePlane.addEventListener('click', (e) => e.stopPropagation());
                    }
                    itemElement.appendChild(interactivePlane);
                })
            }

            if (item.key === 'fireworkThreshold') {


                const bg = document.createElement('a-rounded-plane');
                bg.setAttribute('id', `item-bg-${index}`);
                bg.setAttribute('height', itemHeight);
                bg.setAttribute('width', itemWidth);
                bg.setAttribute('radius', '0.01');
                bg.setAttribute('color', itemBgColor);
                bg.setAttribute('opacity', itemBgOpacity);
                bg.setAttribute('position', `0 ${-itemHeight / 2} 0.002`);
                itemElement.appendChild(bg);

                // main text
                const mainLabel = document.createElement('a-troika-text');
                mainLabel.setAttribute('value', item.label);
                mainLabel.setAttribute('font-size', mainLabelFontSize);
                mainLabel.setAttribute('color', effectiveTxtColor);
                mainLabel.setAttribute('anchor', 'left');
                mainLabel.setAttribute('position', `${padding} 0 0.01`)
                itemElement.appendChild(mainLabel);

                const thresholds = ['+3%', '+5%', '+10%', '+15%'];
                const optionWidth = 0.07;
                const optionHeight = 0.044;
                const xLeft = 0.27;
                const selectedIndex = Math.max(0, thresholds.indexOf(this.data.fireworkThreshold));

                const semitransparentPlane = document.createElement('a-rounded-plane');
                semitransparentPlane.setAttribute('height', optionHeight);
                semitransparentPlane.setAttribute('width', optionWidth * thresholds.length);
                semitransparentPlane.setAttribute('radius', '0.01');
                semitransparentPlane.setAttribute('opacity', itemDisabled ? '0.02' : '0.05');
                semitransparentPlane.setAttribute('color', isLight ? '#000' : '#fff');
                semitransparentPlane.setAttribute('position', `${xLeft} -0.022 0.003`);
                itemElement.appendChild(semitransparentPlane);

                const selectPlane = document.createElement('a-rounded-plane');
                selectPlane.setAttribute('height', optionHeight);
                selectPlane.setAttribute('width', optionWidth);
                selectPlane.setAttribute('radius', '0.01');
                selectPlane.setAttribute('color', itemDisabled ? '#444444' : selectColor);
                selectPlane.setAttribute('position', `${xLeft + optionWidth * selectedIndex} -0.022 0.004`);
                itemElement.appendChild(selectPlane);

                // options
                thresholds.forEach((val, i) => {
                    const centerX = xLeft + optionWidth * i + optionWidth / 2;
                    const optionText = document.createElement('a-troika-text');
                    optionText.setAttribute('value', val);
                    optionText.setAttribute('font-size', 0.018);
                    optionText.setAttribute('anchor', 'center');
                    const isSelected = i === selectedIndex;
                    optionText.setAttribute('color', itemDisabled ? '#666666' : (isSelected ? selectedTextColor : txtColor));
                    optionText.setAttribute('position', `${centerX} 0 0.01`);
                    itemElement.appendChild(optionText);

                    const interactivePlane = document.createElement('a-plane');
                    interactivePlane.setAttribute('height', optionHeight);
                    interactivePlane.setAttribute('width', optionWidth);
                    interactivePlane.setAttribute('opacity', '0');
                    interactivePlane.setAttribute('data-raycastable', '');
                    interactivePlane.setAttribute('position', `${centerX} 0 0.001`);
                    if (!itemDisabled) {
                        interactivePlane.addEventListener('click', () => {
                            console.log('click', i)
                            this.el.setAttribute('configure-control', 'fireworkThreshold', val);
                            this.createSettingsList();

                            if (window.gtag) gtag('event', `VR_CenterPanel_Configure_FireworksThreshold`, { value: val });
                        });
                    } else {
                        interactivePlane.addEventListener('click', (e) => e.stopPropagation());
                    }
                    itemElement.appendChild(interactivePlane);
                })
            }

            const shiftY = 0.22;
            const pos = {
                x: -itemWidth / 2,
                y: -shiftY - index * (itemHeight + itemSpacing) - itemHeight / 2 - padding
            }
            itemElement.setAttribute('position', `${pos.x} ${pos.y} 0`);
            contentElement.appendChild(itemElement);
        })



    },
    update: function (oldData) {
        this._saveSettings();

        try {
            const visualizerEl = document.querySelector('[stock-cube-visualizer]');
            if (visualizerEl) {
                visualizerEl.emit('configure-changed', { settings: this.data }, false);
            }
        } catch (e) {
            console.warn('Failed to emit configure-changed', e);
        }
    },
    
    open: function () {
        this.createSettingsList();
    }
})
